import React, { useState, useEffect } from 'react'
import { useTheme } from '../../ThemeContext'; // Adjust the path as necessary

const Alertypes = ({ type, handleChange }) => {
    const { theme } = useTheme(); // Get the theme from context

    const types = [
        { value: "", Label: "Select Type" },
        { value: "Document", Label: "Document" },
        { value: "Issues", Label: "Issues" },
        { value: "Other", Label: "Other" },

    ]
    return (
        <div>
            <label className="block mb-2 text-sm font-medium">Type</label>
            <select
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}

                onChange={handleChange} value={type}>
                {types.map((t, index) => (
                    <option key={index} value={t.value}>{t.Label}</option>

                ))}
            </select>
        </div>
    )
}

export default Alertypes